<template>
	<div class="texts">
		<table class="texts__text">
			<tr>
				<th style="width: 40%">타이틀</th>
				<th style="width: 40%">플레이스홀더</th>
				<th style="width: 20%">삭제</th>
			</tr>
			<tr v-for="(text, idx) in inputTexts" :key="idx">
				<td>
					<label>
						<textarea
							@input="emitEvent"
							v-model="text.title"
							placeholder="타이틀을 설정해주세요."
						></textarea>
					</label>
				</td>
				<td>
					<label>
						<textarea
							@input="emitEvent"
							v-model="text.option[0].placeholder"
							placeholder="플레이스 홀더 문구를 입력해주세요."
						></textarea>
					</label>
				</td>
				<td style="text-align: center; vertical-align: middle">
					<button
						v-if="inputTexts.length > 1"
						@click="removeItem(idx)"
						class="item__remove"
					>
						<i class="fa fas fa-minus"></i>
					</button>
				</td>
			</tr>
		</table>
		<div class="text__button-wrapper">
			<button
				v-if="inputTexts.length < 3"
				@click="addItem()"
				class="item__add"
			>
				<i class="fa fas fa-plus"></i>
			</button>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'ApplyInputText',
		data() {
			return {
				inputTexts: [{ title: '', option: [{ placeholder: '' }] }],
			};
		},
		props: {
			isApply: {
				type: Boolean,
				default: [],
			},
		},
		methods: {
			setTexts(texts) {
				this.inputTexts = texts;
				this.emitEvent();
			},
			isEmptyValue() {
				let isEmpty = false;

				_.each(this.inputTexts, option => {
					if (option.title.trim().length === 0) {
						isEmpty = true;
					}

					_.each(option.option, each => {
						if (each.placeholder.trim().length === 0) {
							isEmpty = true;
						}
					});
				});

				return isEmpty;
			},
			addItem() {
				if (!this.checkApplicant()) {
					return false;
				}
				this.inputTexts.push({
					title: '',
					option: [{ placeholder: '' }],
				});
				this.emitEvent();
			},
			removeItem(index) {
				if (!this.checkApplicant()) {
					return false;
				}
				this.inputTexts.splice(index, 1);
				this.emitEvent();
			},
			emitEvent() {
				this.$emit('change', this.inputTexts);
			},
			checkApplicant() {
				if (this.isApply) {
					alert(
						'이미 이벤트를 참여한 유저가 있어 신청 정보 수정이 불가합니다.'
					);
					return false;
				}
				return true;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.texts__text {
		margin: 1em 0;
		border-top: 1px solid #ebebed;
		table-layout: fixed;

		th {
			padding: 1em;
			text-align: center;
			background: #f4f7fa;
			color: #657088;
			border-bottom: 1px solid #ebebed;
			vertical-align: middle;
		}

		td {
			padding: 1em;
			color: #657088;
			border-bottom: 1px solid #ebebed;
		}
	}

	.item__add {
		background: $btn-blue;
		width: 1.6em;
		height: 1.6em;
		border-radius: 50%;
		color: #fff;
	}

	.item__remove {
		@extend .item__add;
		background: #ff3860;
		font-size: 0.75rem;
		vertical-align: middle;
	}

	.text__button-wrapper {
		text-align: center;
	}
</style>
